import ko from '@tko/build.knockout';
import _ from 'lodash';
import $ from 'jquery';
import EndpointsCommon from '../../../app/helpers/endpoints-common';
import DataRepository from '../../../app/data-framework/data-repository';
import DataProvider from '../../../app/data-framework/data-provider';
import templateMarkup from 'raw-loader!./endpointmgmtgrid-widget.html';
import Signals from 'signals';

    

    function EndpointMgmtGridWidget(params) {
        this.observableOptions = params.observableOptions;
        this.observableData = params.observableData;
        this.panelTemplate = params.panelTemplate;
        this.widgetSignals = params.widgetSignals;

        this.dataProvider = DataProvider.getInstance();
        this.dataRepository = DataRepository.getInstance();

        this.rowClickCallback = this.rowClickHandler.bind(this);
        this.editMultipleCallback = this.bulkEditEndpoints.bind(this);
        this.ids = null;

        this.updateModalSignals = ko.observable({
            showSingleUpdateModal: new Signals.Signal(),
            showBulkUpdateModal: new Signals.Signal(),
            onUpdateEndpoint: new Signals.Signal(),
            onAppendTags: new Signals.Signal()
        });

        this.signalListeners = {
            onUpdateEndpoint: this.updateEndpoint.bind(this),
            onAppendTags: this.appendTags.bind(this)
        };
        this.updateModalSignals().onUpdateEndpoint.add(this.signalListeners.onUpdateEndpoint);
        this.updateModalSignals().onAppendTags.add(this.signalListeners.onAppendTags);

        this.typeaheadOptions = this.dataRepository.getEndpointManagementMetadata().filterConditions;
    }

    EndpointMgmtGridWidget.prototype = {
        rowClickHandler: function (row, columnIndex) {
            var data = this.observableData();

            if (!_.isEmpty(data) && data.rowProperties[columnIndex] === 'edit') {
                this.editEndpoint(row);
            }
        },

        editEndpoint: function (endpoint) {
            this.updateModalSignals().showSingleUpdateModal.dispatch({
                id: endpoint.id,
                altName: _.unescape(endpoint.altName),
                description: _.unescape(endpoint.description),
                location: _.unescape(endpoint.location),
                price: _.unescape(endpoint.price),
                tags: _.unescape(endpoint.customTags),
                tmsTag: _.unescape(endpoint.tmsTags),
                saveCallback: _.bind(this.updateEndpoint, this)
            });
        },

        bulkEditEndpoints: function (ids) {
            this.updateModalSignals().showBulkUpdateModal.dispatch({ ids: ids});
        },

        appendTags: function (model) {
            var endpoints = ko.unwrap(this.dataProvider.getListOfEndpointsWithIdsObservable());
            var ids = model.ids;
            var tags = model.tags;

            var models = _.map(ids, function (id) {
                var modelTags = _.get(_.find(endpoints, ['id', id]), 'tags', '').split(',');
                var inputTags = EndpointsCommon.tagsTokenToArray(tags || []);
                var updatedTags = _.chain(modelTags).concat(inputTags).uniq().compact().value().join(',');

                return {
                    id: id,
                    tags: updatedTags
                };
            });

            return this.saveData.call(this, models);
        },

        updateEndpoint: function (input) {
            var ids = !_.isEmpty(input.ids) ? input.ids : [input.id];
            var singleMode = _.isEmpty(input.ids) || (input.ids.length <= 1);

            var models = _.map(ids, function (id) {
                var model = {};

                _.forEach(input, function (value, key) {
                    if (_.isString(value)) {
                        model[key] = _.trim(value);
                    }

                    if (!singleMode && _.isEmpty(value)) {
                        return delete model[key];
                    }

                    model[key] = value;
                });

                model.id = id;

                if (singleMode || !_.isEmpty(input.tags)) {
                    model.tags = EndpointsCommon.tagsTokenToRaw(input.tags);
                }
                return model;
            });

            return this.saveData.call(this, models);
        },

        dispose: function() {
            this.updateModalSignals().onUpdateEndpoint.remove(this.signalListeners.onUpdateEndpoint);
            this.updateModalSignals().onAppendTags.remove(this.signalListeners.onAppendTags);
            delete this.signalListeners;
        },

        saveData: function (models) {
            var successCount = 0;

            models.forEach(function (model) {
                // tmsTag is considered to be a read-only property at the UI level.
                // TODO: Remove tmsTag cleansing once we allow users to update tmsTags from the UI
                delete model.tmsTag; // remove the tmsTag property from the model so we don't update it on the backend

                this.dataProvider.updateEndpoint(model.id, model).then(_.bind(function () {
                        successCount++;

                        if (successCount === models.length) {
                            this.refreshGrid();
                        }
                    }, this))
                    .catch(function () {
                        throw new Error(JSON.stringify(model));
                    });
            }.bind(this));
        },

        refreshGrid: function () {
            if (this.widgetSignals) {
                this.widgetSignals().dataRequested.dispatch();
            }
            // TODO: Ask platform team why sometimes GetSystemStatusXML doesn't have updated info (e.g. tags)
            // if call after we get a response for UpdateEndpoints
            window.setTimeout(_.bind(function () {
                this.dataRequested = true;
                this.dataProvider.refreshDataSources(this.panelTemplate.dataSources);
            }, this), 1000);
        }
    };

    function getDataFor(elementId) {
        return ko.dataFor($("#" + elementId)[0].firstChild);
    }

    export default {
        viewModel: EndpointMgmtGridWidget,
        template: templateMarkup
    };
